import React from 'react';
import { BarChart,Bar, XAxis, YAxis, CartesianGrid, Tooltip, Label, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';

const RepurchaseRateChart = ({ dir, height, dataToPlot, index }) => {
    const thisMonthData = {};
    return (        
        <ResponsiveContainer width="100%" height={height} style={{ marginTop: '50px' }}>
                    <BarChart
                        width={500}
                        height={400}
                        data={dataToPlot}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                        <XAxis dataKey="day" reversed={dir === 'rtl'} />
                        <YAxis yAxisId="left" type="number" allowDataOverflow>
                        <Label angle={-90} value="Repurchase Rate (%)"
                        position='insideLeft' style={{ textAnchor: 'middle' }} />
                        </YAxis>               
                        <Tooltip formatter={value => `${setCurrencyFormat(Number(value).toFixed(2), false)} %`} />
                        <Legend />
                        <Bar
                                            stackId="count"
                                            yAxisId="left"
                                            // fill={color1}
                                            fill="#F5BD61"
                                            dataKey={"RepurchaseRate"?.toString()}
                                            stroke="#000000"
                                            barSize={40}
                                        />
                    </BarChart>
                </ResponsiveContainer>
    )
}

RepurchaseRateChart.propTypes = {
    dir: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    index: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
};

RepurchaseRateChart.defaultProps = {
    index: 0
  }

export default React.memo(RepurchaseRateChart);